import React, { Component } from "react";
import deepEquals from "../../utils/deepEquals";
import {
    setDataInStore,
    getEmptyContent,
    resolveBinding,
    resolveChild,
    resolveChildren,
    resolveRegions,
    resolveCollectionItems,
    dispatchSirenActions,
    saveState,
    buildEnumData
} from "../../utils/containerUtils";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export default class BaseComponent extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        let equalProps = deepEquals(this.props, nextProps);
        let equalState = deepEquals(this.state, nextState);

        let different = !equalProps || !equalState;
        //let type = this.props.config?this.props.config.type:"uknown";

        if (different) {
            //console.log(this.props.computedBindTo + "(" + type + ") will render.")
        } else {
            //console.log(this.props.computedBindTo + "(" + type + ") will NOT render.")
        }

        return different;
    }

    //Method to set data into redux state.
    //Will check if the new data is different than what we have in store atm.
    //Returns true if set was triggered!
    //Requires triggerSet to be defined in the container!!!
    setDataInStore(toSet) {
        return setDataInStore(this.props, toSet);
    }

    //for performance measurements
    // componentDidUpdate() {
    //     let type = this.props.config?this.props.config.type:"uknown";
    //
    //     console.log(this.props.computedBindTo + "(" + type + ") rendered.")
    // }

    getEmptyContent(emptyText) {
        return getEmptyContent(emptyText, this.constructor.name);
    }

    //used to resolve binding for not connected components
    resolveBinding() {
        return resolveBinding(this.props);
    }

    resolveChild(childConfig, index, options = {}) {
        return resolveChild(this.props, childConfig, index, options);
    }

    resolveChildren(options = {}) {
        return resolveChildren(this.props, options);
    }

    resolveRegions(options = {}) {
        return resolveRegions(this.props, options);
    }

    resolveCollectionItems(options = {}) {
        return resolveCollectionItems(this.props, options);
    }

    dispatchSirenActions(targetEvent, childDispatching = {}, options = {}) {
        return dispatchSirenActions(this.props, targetEvent, childDispatching, options);
    }

    saveState(newValue, state = {}, extraState = {}) {
        saveState(this.props, newValue, state, extraState);
    }

    buildEnumData() {
        return buildEnumData(this.props);
    }

    //adding default render for rendering unknown components
    render() {
        WEBUILogs.error("Unknown component rendered:");
        WEBUILogs.error(this.props.config);
        return <div className={"unknownComponent"} />;
    }
}
